import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=bfde31a8&scoped=true&"
import script from "./Statistics.vue?vue&type=script&lang=js&"
export * from "./Statistics.vue?vue&type=script&lang=js&"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=bfde31a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfde31a8",
  null
  
)

export default component.exports